import React from 'react';
import { Container} from 'react-bootstrap';
import banner from "../assets/images/banner.webp";
import arrowLeft from "../assets/images/arrow-left.png";
import { Link } from 'react-router-dom';

const LearnAboutUs = () => {
  return (
    <div className='app-container mobile-bottom'>
      <Container>
      <div className='breadcrum bg_light_yellow'>
          <h2 className='d-flex align-items-center fs-20 mb-0'>
          <Link to='/dashboard'><img src={arrowLeft} width={18} className='me-2' alt="link" /></Link>
            Learn About Us</h2>
        </div>
        <h3 className='welcomeText mt-3'>
          <span className='small-hello fs-10'>Welcome to </span>
          <span className='bigg-name text-danger fs-18'>The Pied Piper!</span>
        </h3>

        <div className='midtext fs-12'>
          <p>We're more than just a kids' club—we're a vibrant space where imagination leads the way. Our unique approach focuses on creativity, life skills, and fun, offering an environment that sparks joy and discovery.</p>
          <p>At The Pied Piper, every child is celebrated for their individuality. We’re not about rigid curriculums or traditional classroom settings. Instead, we provide experiences that allow children to explore their passions, express themselves freely, and build skills that will last a lifetime.</p>
          <p>Explore our story, meet our team, and see why families trust us to nurture their children’s growth.</p>
        </div>
        <div className='normal_image mb-5 mt-4'>
          <img
            src={banner}
            alt="main"
            className="img-fluid" />
        </div>
      </Container >
    </div >
  );
}

export default LearnAboutUs;
